import { EmployeeDirectoryImportState } from './employee-directory-import-selectors';
import { STARTING, SUCCESS, FAILURE } from '../action/util/action-name-creators';
import { Action, updateResourceByParam } from '../reducers/utils/state-manager';

import { convertArrayToMap } from '../util/convert-array-to-map';

const InitialState: EmployeeDirectoryImportState = {
  employeeDirectoryImportsById: {},
  employeeDirectoryImportsStateByOrgId: {},
};

export const employeeDirectoryImportReducer = (state = InitialState, action: Action) => {
  switch (action.type) {
    case STARTING('LOAD_EMPLOYEE_DIRECTORY_IMPORTS'): {
      const { orgId } = action.payload.args;
      return updateResourceByParam(state, 'employeeDirectoryImports', 'orgId', orgId, true);
    }
    case SUCCESS('LOAD_EMPLOYEE_DIRECTORY_IMPORTS'): {
      const {
        args: { orgId },
        data,
      } = action.payload;
      return updateResourceByParam(
        state,
        'employeeDirectoryImports',
        'orgId',
        orgId,
        false,
        convertArrayToMap(data, (d: EmployeeDirectoryImport) =>
          String(d.employeeDirectoryImportId),
        ),
      );
    }
    case FAILURE('LOAD_EMPLOYEE_DIRECTORY_IMPORTS'): {
      const { orgId } = action.payload.args;
      return updateResourceByParam(state, 'employeeDirectoryImports', 'orgId', orgId, false);
    }
    case SUCCESS('CREATE_EMPLOYEE_DIRECTORY_IMPORT'):
    case SUCCESS('UPDATE_EMPLOYEE_DIRECTORY_IMPORT'): {
      const { data } = action.payload;
      const { employeeDirectoryImportId, orgId } = data;

      return updateResourceByParam(state, 'employeeDirectoryImports', 'orgId', orgId, false, {
        [employeeDirectoryImportId]: data,
      });
    }
    default: {
      return state;
    }
  }
};
